import { Navigate, Outlet } from 'react-router-dom';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';
import { useAuth } from '../contexts/AuthContext';
import { getStoredAccessToken } from '../services/apiClient';

export function PortalRoute() {
  const { isLoading, profile } = useAuth();

  if (isLoading) {
    return <LoadingSpinner label="Validando sessão..." />;
  }

  if (!getStoredAccessToken() || !profile) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
